import { render, staticRenderFns } from "./ComplaintModal.vue?vue&type=template&id=bd4add58&scoped=true"
import script from "./ComplaintModal.vue?vue&type=script&lang=js"
export * from "./ComplaintModal.vue?vue&type=script&lang=js"
import style0 from "./ComplaintModal.vue?vue&type=style&index=0&id=bd4add58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4add58",
  null
  
)

export default component.exports